/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type OnboardingSlackStepQueryVariables = {
    orgRelayId: string;
};
export type OnboardingSlackStepQueryResponse = {
    readonly org: {
        readonly " $fragmentRefs": FragmentRefs<"OnboardingSlackStep_org">;
    } | null;
};
export type OnboardingSlackStepQuery = {
    readonly response: OnboardingSlackStepQueryResponse;
    readonly variables: OnboardingSlackStepQueryVariables;
};



/*
query OnboardingSlackStepQuery(
  $orgRelayId: ID!
) {
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      ...OnboardingSlackStep_org
    }
    id
  }
}

fragment OnboardingSlackStep_org on Org {
  id
  experiments
  slackAccountsErrorable {
    __typename
    ... on SlackAccountList {
      list {
        id
        slackTeamId
        slackUserId
        teamDisplayName
        needsUpdate
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  slackSettingsErrorable {
    __typename
    ... on SlackSettingsList {
      list {
        id
        slackTeamId
        slackUserId
        calendarStatus {
          calendarStatusEnabled
          includeMeetingCategory
          includeMeetingTitle
        }
        dailyDigestSettings {
          enabled
          timeSlot
        }
        dndSettings {
          focusTime
          meeting
        }
        notificationSettings {
          defragSummary
        }
        calendarStatusEnabled
        includeMeetingCategory
        includeMeetingTitle
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgRelayId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slackTeamId",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slackUserId",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarStatusEnabled",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "includeMeetingCategory",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "includeMeetingTitle",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "OnboardingSlackStepQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "OnboardingSlackStep_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "OnboardingSlackStepQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "experiments",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "slackAccountsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SlackAccount",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v3 /*: any*/),
                                                        (v4 /*: any*/),
                                                        (v5 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "teamDisplayName",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "needsUpdate",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "SlackAccountList",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v6 /*: any*/),
                                                (v7 /*: any*/)
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "slackSettingsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SlackSettings",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v3 /*: any*/),
                                                        (v4 /*: any*/),
                                                        (v5 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SlackCalendarStatusSync",
                                                            "kind": "LinkedField",
                                                            "name": "calendarStatus",
                                                            "plural": false,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v10 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SlackDailyDigestSettings",
                                                            "kind": "LinkedField",
                                                            "name": "dailyDigestSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "enabled",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "timeSlot",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SlackDndSettings",
                                                            "kind": "LinkedField",
                                                            "name": "dndSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "focusTime",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "meeting",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "SlackNotificationSettings",
                                                            "kind": "LinkedField",
                                                            "name": "notificationSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "defragSummary",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v10 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "SlackSettingsList",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v7 /*: any*/),
                                                (v6 /*: any*/)
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "2e2bf8fbc0adb393938cc81f25838954",
            "id": null,
            "metadata": {},
            "name": "OnboardingSlackStepQuery",
            "operationKind": "query",
            "text": "query OnboardingSlackStepQuery(\n  $orgRelayId: ID!\n) {\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...OnboardingSlackStep_org\n    }\n    id\n  }\n}\n\nfragment OnboardingSlackStep_org on Org {\n  id\n  experiments\n  slackAccountsErrorable {\n    __typename\n    ... on SlackAccountList {\n      list {\n        id\n        slackTeamId\n        slackUserId\n        teamDisplayName\n        needsUpdate\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  slackSettingsErrorable {\n    __typename\n    ... on SlackSettingsList {\n      list {\n        id\n        slackTeamId\n        slackUserId\n        calendarStatus {\n          calendarStatusEnabled\n          includeMeetingCategory\n          includeMeetingTitle\n        }\n        dailyDigestSettings {\n          enabled\n          timeSlot\n        }\n        dndSettings {\n          focusTime\n          meeting\n        }\n        notificationSettings {\n          defragSummary\n        }\n        calendarStatusEnabled\n        includeMeetingCategory\n        includeMeetingTitle\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'f2eff24572b2cd21b48e64bd5e48f2b8';
export default node;
